// Small formatting helpers shared by the chart components and the report data
// adapters. Lives here (not in a Pages module) so components never have to
// import from a page.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * "2026-07-08" -> "8 Jul".
 *
 * Parsed by splitting the string rather than via `new Date(s)`, because the Date
 * constructor treats a bare "YYYY-MM-DD" as UTC midnight and would render the
 * previous day for anyone west of Greenwich.
 */
export function formatDayLabel(ymd) {
    if (!ymd) return '';
    const [, m, d] = String(ymd).split('-').map(Number);
    if (!m || !d) return String(ymd);
    return `${d} ${MONTHS[m - 1] || ''}`;
}
